import { Routes, Route } from "react-router-dom";
import UploadPage from "./pages/UploadPage.tsx";
import DownloadPage from "./pages/DownloadPage.tsx";

function App() {
  return (
    <div className="container">
      <header className="header">
        <h1>Dzajdrop</h1>
        <p>Secure file sharing via Discord storage</p>
      </header>

      <Routes>
        <Route path="/" element={<UploadPage />} />
        <Route path="/d/:linkId" element={<DownloadPage />} />
      </Routes>
    </div>
  );
}

export default App;
